<template>
  <v-card elevation="2" color="#EEEEEE">
    <v-card-title class="application-heading pt-0 pb-0">
      Scribe Content Summary
      <v-spacer></v-spacer>
      <span class="text-sm-body-2 pr-2" v-if="isFolderOwner">{{
        reportDisplayLabel
      }}</span>
      <v-switch
        class="pull-right"
        v-model="isSummaryVisible"
        x-small
        v-if="isFolderOwner"
        @change="handleUpdateFolderReport"
      >
      </v-switch>
    </v-card-title>
    <v-card-text>
      {{ summary }}
    </v-card-text>
    <v-card-title class="application-heading pb-0 pt-0">
      Folder Report
      <v-spacer></v-spacer>
      <v-icon
        small
        class="pull-right fa fa-pencil-alt"
        @click="showForm()"
        v-if="isFolderOwner"
      ></v-icon>
    </v-card-title>
    <v-card-text>
      <v-row dense row v-show="!isEditable">
        <v-col class="col-12">
          <span>{{ description }} </span>
        </v-col>
      </v-row>
      <v-row dense row v-show="isEditable">
        <v-col class="col-12">
          <v-textarea
            ref="description"
            v-model="description"
            placeholder="Enter a folder description"
            :rows="3"
            :loading="reportUpdating"
            class="hyp-folder-note-textarea my-0 py-0"
          ></v-textarea>
        </v-col>
        <v-col>
          <v-btn class="button primary" @click="handleUpdateFolderReport">
            Save
          </v-btn>
          <v-btn class="button primary ml-2" @click="handleCancelFolderReport">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import lodashGet from "lodash/get";
import lodashHas from "lodash/has";
import lodashDebounce from "lodash/debounce";
import {
  getFolderSummary,
  saveFolder,
} from "@/services/collaboration/folders.service";
import { MODULE_PREFIX_COLLABORATION, MODULE_PREFIX_HOME } from "@/store";
import { GET_COLLABORATION_FOLDERS, GET_NOTIFIER } from "@/store/actions.type";
import { NOTIFIER_TYPES } from "@/common/constants/misc";
import lodashIsEqual from "lodash/isEqual";
import { mapGetters } from "vuex";

export default {
  name: "CollaborationFolderSummary",
  props: {
    selectedFolder: {
      type: Object,
    },
  },
  data: function () {
    return {
      isEditable: false,
      isSummaryVisible: false,
      folder: null,
      description: null,
      reportUpdating: false,
      summary: null,
    };
  },
  mounted() {
    this.folder = this.selectedFolder;
    this.initialize();
  },
  computed: {
    ...mapGetters({
      notifier: MODULE_PREFIX_HOME + "notifier",
    }),
    isFolderOwner() {
      return this.folder && this.folder.isOwner;
    },
    reportDisplayLabel() {
      return this.folder && this.folder.is_report_visible
        ? "Hide Report"
        : "Show Report";
    },
  },
  methods: {
    initialize() {
      this.loadFolderSummary();
    },
    async loadFolderSummary() {
      try {
        this.description = null;
        if (lodashGet(this.folder, "report_description")) {
          this.description = this.folder.report_description;
        }
        this.isSummaryVisible = lodashHas(this.folder, "is_report_visible")
          ? this.folder.is_report_visible
          : false;
        this.summary = await getFolderSummary({ folder: this.folder });
      } catch (err) {
        console.error("There was an error loading the folder summary");
        console.error(err);
      }
    },
    handleUpdateFolderReport() {
      if (this.isEditable) {
        this.reportUpdating = true;
      }
      this.folder.report_description = this.description;
      this.folder.is_report_visible = this.isSummaryVisible;
      lodashDebounce(async () => {
        try {
          await saveFolder({
            folder: this.folder,
          });
          await this.$store.dispatch(
            MODULE_PREFIX_COLLABORATION + GET_COLLABORATION_FOLDERS,
            { force: true }
          );
          if (this.isEditable) {
            this.toggle();
          }
        } catch (err) {
          this.notifier.isEditable = true;
          this.notifier.type = NOTIFIER_TYPES.error;
          this.notifier.message = "Failed : " + err.message;
          await this.$store.dispatch(
            MODULE_PREFIX_HOME + GET_NOTIFIER,
            this.notifier
          );
        }
        if (this.isEditable) {
          this.reportUpdating = false;
        }
      }, 0)();
    },
    toggle() {
      this.isEditable = !this.isEditable;
    },
    showForm() {
      this.toggle();
      this.$refs.description.focus();
    },
    handleCancelFolderReport() {
      if (lodashGet(this.folder, "report_description")) {
        this.description = this.folder.report_description;
      }
      this.toggle();
    },
  },
  watch: {
    selectedFolder: {
      handler(newValue, oldValue) {
        if (!lodashIsEqual(newValue, oldValue)) {
          this.loadFolderSummary();
        }
      },
    },
  },
};
</script>

<style scoped>
.hyp-folder-note-textarea {
  font-size: 14px;
  width: 93%;
}
</style>
